var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnhealthyFaceBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.6,
    height: 30.6,
    viewBox: "0 0 30.6 30.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unhealthy_icon",
    "data-name": "Unhealthy icon",
    transform: "translate(0.8 0.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2934",
    "data-name": "Path 2934",
    d: "M361,388h14.359a.141.141,0,0,1,.141.141V402.5A14.5,14.5,0,0,1,361,417h0a14.5,14.5,0,0,1-14.5-14.5h0A14.5,14.5,0,0,1,361,388Z",
    transform: "translate(-346.5 -388)",
    fill: "none",
    stroke: "#030504",
    strokeWidth: 1.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(6.118 5.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2935",
    "data-name": "Path 2935",
    d: "M361.047,399.843l-2.151-2.151-2.151,2.151-1.051-1.051,3.2-3.2,3.2,3.2Z",
    transform: "translate(-354.975 -395.589)",
    fill: "#030504",
    stroke: "#030504",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2936",
    "data-name": "Path 2936",
    d: "M373.047,399.843l-2.151-2.151-2.151,2.151-1.051-1.051,3.2-3.2,3.2,3.2Z",
    transform: "translate(-358.052 -395.589)",
    fill: "#030504",
    stroke: "#030504",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2937",
    "data-name": "Path 2937",
    d: "M370.107,415.056a7.645,7.645,0,0,0-13.994,0l-1.385-.541a9.13,9.13,0,0,1,16.765,0Z",
    transform: "translate(-354.727 -399.029)",
    fill: "#030504",
    stroke: "#030504",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnhealthyFaceBlack);
export default __webpack_public_path__ + "static/media/unhealthyFaceBlack.58b04cdb3954f6d0d8beb30bc432946f.svg";
export { ForwardRef as ReactComponent };